import { DashboardHeaderDropdownMenu } from '@/app/(dashboard)/DashboardHeaderDropdownMenu'
import { CreateFolderDialog } from '@/app/(dashboard)/folders/CreateFolderDialog'
import { useDashboardPermissions } from '@/app/core/hooks/dashboard/useDashboardPermissions'
import { CreateProjectDialog } from '@/app/(dashboard)/projects/CreateProjectDialog'
import { Icon, Tooltip } from '@/dc-shared-web/src'
import { faFileText } from '@document-crunch/pro-regular-svg-icons'
import { useState } from 'react'

const TooltipContent: Record<'dashboard' | 'archived' | 'shared', string> = {
  dashboard: 'Total active crunches in team',
  archived: 'Total archived crunches in team',
  shared: 'Total shared crunches in team',
}

export const DashboardHeader = ({
  documentCount,
  children,
  currentTable,
  selectedTeamId,
}: {
  documentCount: number
  children: React.ReactNode
  currentTable: 'dashboard' | 'archived' | 'shared'
  selectedTeamId: string
}) => {
  const [selectedDialog, setSelectedDialog] = useState<
    'folder' | 'project' | null
  >(null)
  const onDialogClose = () => setSelectedDialog(null)
  const { canAddFolder, canAddProject, shouldShowCreateActionsMenu } =
    useDashboardPermissions('dashboard')
  const tooltipContent = TooltipContent[currentTable]
  return (
    <div className='tw-flex tw-gap-3 tw-items-center'>
      <h1 className='tw-text-2xl tw-font-medium' data-testid='dashboard-title'>
        {children}
      </h1>
      <div className='tw-flex tw-gap-1 tw-flex-grow tw-justify-between'>
        <Tooltip withArrow content={tooltipContent}>
          <span
            className='tw-bg-neutral-50 tw-px-1.5 tw-py-1 tw-rounded-sm tw-border tw-border-neutral-100 tw-flex tw-gap-2 tw-items-center'
            data-testid='count-span'
          >
            <figure
              className='tw-flex tw-gap-2 tw-items-center'
              aria-live='polite'
            >
              <Icon icon={faFileText} size='xs' aria-hidden='true' />
              <output
                className='tw-text-2xs tw-font-extralight tw-text-neutral-400'
                aria-label={`${documentCount} ${tooltipContent}`}
              >
                {documentCount}
              </output>
            </figure>
          </span>
        </Tooltip>
      </div>
      <DashboardHeaderDropdownMenu
        onSelectItem={setSelectedDialog}
        shouldShowCreateActionsMenu={shouldShowCreateActionsMenu}
        canAddFolder={canAddFolder}
        canAddProject={canAddProject}
      />
      {selectedDialog === 'folder' ? (
        <CreateFolderDialog
          onDialogClose={onDialogClose}
          teamUuid={selectedTeamId}
        />
      ) : null}
      {selectedDialog === 'project' ? (
        <CreateProjectDialog onDialogClose={onDialogClose} />
      ) : null}
    </div>
  )
}
